<template>
    <div class="newreleasenetflix">
        <h2 class="netflix-release-header">Netflix New Release</h2>
            <!-- test -->
            <div class="test newrelease" ref="users">
                <div class="leftarrow" v-on:click="leftarrow()"><img src="../images/chevron-left-solid.svg"></div>
                <div class="rightarrow" v-on:click="rightarrow()"><img src="../images/chevron-right-solid.svg"></div>
            <div class="netflixrelease">
                <div class="netflixpopular" v-for=" (netflixsecondgenre,index) in netflixsecondgenres"  v-bind:key="index">
                    <div class="netflix-original-images">
                        <img :src="`https://image.tmdb.org/t/p/original`+`${netflixsecondgenre.backdrop_path}`">
                        <p> {{ netflixsecondgenre.original_name}} </p>
                        <div class="desc-part">
                        <div class="icon">
                            <img src="../images/play-circle-solid.svg">
                            <img src="../images/plus-circle-solid.svg">
                            <img src="../images/thumbs-up-solid.svg">
                            <img src="../images/thumbs-down-solid.svg">
                        </div>
                        <div class="desc-sec">
                             <span class="match" style="color:green">{{netflixsecondgenre.vote_average}}% Match</span>
                             <span>{{ netflixsecondgenre.overview }}</span>
                         </div>
                    </div>
                    </div>
                    </div>
                </div>
                
            </div>

</div>

</template>


<script>
import axios from 'axios';
const API_KEY = "c20644006c1a56f0c5eca8d53b6ccf4e";
export default {
    data(){
        return{
              netflixsecondgenres:[],
        }
    },
    created(){
          // trending
         axios.get(`https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&width_genres=35`)
            .then(secondgenre => {
            console.log(secondgenre.data.results)
            this.netflixsecondgenres = secondgenre.data.results;
            })
    },
    methods:{}    
  
}
</script>

<style scoped>
.newreleasenetflix{
    margin-top: -17vw;
}
.netflix-origional::-webkit-scrollbar,.netflix-trending::-webkit-scrollbar{
    display: none;
}
.netflixpopular{
      transition: transform .3s;
}
.netflixpopular:hover{
     transform: scale(1.5);
        z-index: 5000;
}
 .netflix-original-images{
       width:15vw;
       height:10vw;
       margin-left: 0.2vw;
   }
   .netflix-original-images img{
       height: 100%;
        width: 100%;
        object-fit: contain;
        object-position: center;
   }
   .netflix-original-images p{
    top: 20%;
    position: absolute;
    transform: translateY(-20%);
        width: 100%;
    font-size: 1vw;
    text-align: center;
    font-family: 'Rock Salt', cursive;
   }
   .original .netflix-original-images{
        width: 15vw;
        height: 13vw;

   }
    .leftarrow,.rightarrow{
      color:white;
  }
  .leftarrow{
  z-index: 50;
     position: absolute;
    height: max-content;
    margin-top: 80px;
    width: 30px;
    visibility: hidden;
  }
  .rightarrow{
      z-index: 50;
     position: absolute; 
    right: 77px;
    margin-top: 80px;
    width: 30px;
    visibility: hidden;
  }
  .netflix-origional:hover .leftarrow,
  .netflix-origional:hover .rightarrow{
   visibility: visible;
  }
  .netflixrelease{
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 3vw 0 22vw 0;
  }

    .desc-part{
    color: white;
    height:auto;
    background-color:black;
    z-index: -10;
    transition: 0.1s ease-in;
    visibility: hidden;
    margin-top: -1.5vw;
  }
   .netflixpopular:hover .desc-part{
       visibility: visible;
   }
  .desc-part .icon{
   padding: 20px;
   overflow: hidden;
   display: flex;

  }
  .desc-part .icon img{
      height: 1vw;
      width: 1vw;
      border:1px solid white;
      border-radius: 50%;
      padding: 0.5vw;
      margin-left: 10px;
  }
  .netflixrelease::-webkit-scrollbar{
    display: none;
}
.netflix-release-header{
    color: white;
}
.desc-sec{
      padding: 0 1vw 1vw 1vw;
  }
  .desc-sec span{
      font-size: 10px;
      color: white;
      margin-top: 0vw;
  }
  .match{
      color:green;
      display: block;
      font-weight: 700;
  }
</style>